import React from 'react'
import { useSelector } from 'react-redux'

import withMemo from '../../decorators/WithMemo'
import { selectors as AppSelectors } from '../../redux/app/redux'
import EventTemplate from '../../templates/Event'

import { selectors } from './redux'
import EventSagas from './sagas'


const Event = () => {
  const data = useSelector(selectors.data)
  const isLoaded = useSelector(selectors.isLoaded)
  const breadcrumb = useSelector(AppSelectors.breadcrumb)

  if (data === null || isLoaded === false) {
    return null
  }

  return (
    <EventTemplate
      data={data}
      breadcrumb={breadcrumb}
    />
  )
}

Event.getInitialProps = async(ctx, store) => (
  store.saga.run(EventSagas.init, ctx).done
)

Event.propTypes = {}

export default withMemo()(Event)
